<template>
  <div>
    <!-- header-->
    <headertop></headertop>
    <el-row class="main" style="padding-top: 1.875rem;">
      <el-col  :offset="1" :span="22">
        <el-input v-model="input" placeholder="请输入内容" @keyup.enter.native="search_click()"  style="width: 30%;float: right;margin-bottom: 1.875rem;" />
        <el-table
            :data="list_info.list.data"
            border>
            <el-table-column
              fixed
              prop="title"
              label="名称"
             >
            </el-table-column>
            <el-table-column
              fixed
              prop="time"
              label="时间"
             >
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              width="200">
              <template slot-scope="scope">
                <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">查看原文</el-button> -->
                <a style="text-decoration: none; color: #66b1ff;"  :href="scope.row.href" target="_blank">查看原文</a>
                <a style="text-decoration: none; color:rgb(103, 194, 58) ; margin-left: 0.3125rem;"   v-if="scope.row.map!=''&&scope.row.map!=null " :href="scope.row.map" target="_blank">查看导图</a>

              </template>
            </el-table-column>
          </el-table>
          <!-- <el-row style="text-align: center;margin-top: 1.25rem;">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage4"
              :page-sizes="[100, 200, 300, 400]"
              :page-size="100"
              layout="total, sizes, prev, pager, next, jumper"
              :total="400">
            </el-pagination>
          </el-row> -->
          <div class="block center">
            <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
              :current-page="list_info.currentPage" :page-sizes="[5, 10, 25, 50]" :page-size="list_info.pageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="list_info.total">
            </el-pagination>
          </div>
      </el-col>
    </el-row>
    <!-- footer -->
    <footerbom></footerbom>

  </div>
</template>

<script>
  import Header from '../../../components/index/public/NavHeader.vue';
  import Footer from '../../../components/index/public/NavFooter.vue';
  export default {
    data() {
      return {
        input:'',
        list_info:{
          list:[],
          currentPage:1, // 当前页码
          total:0, // 总条数
          pageSize:5,
        }
      }
    },

    components: {
      headertop: Header,
      footerbom: Footer
    },
    mounted:function(){
      this.get_info()
    },
    methods: {
      get_info(){
          let _this = this;
            _this.axios
          .get("/v2/user_resource/wechat_list",
          {params:{limit:_this.list_info.pageSize,page:_this.list_info.currentPage,key:_this.input}}).then(function (res) {
            if (res.status == "200") {
              if (res.data.code == "1") {
                _this.list_info.list=res.data.data
                _this.list_info.pageSize=res.data.data.per_page
                _this.list_info.total=res.data.data.total
                _this.list_info.current_page=res.data.data.current_page
              } else {
                _this.$message.error(res.data.data.msg)
              }
            } else {
              _this.$message.error("服务器内部错误")
            }
          });
        },
        handleSizeChange(val) {
          this.list_info.currentPage = 1
          this.list_info.pageSize = val
          this.get_info()
        },
        handleCurrentChange(val) {
          this.list_info.currentPage = val
          this.get_info()
        },
        search_click(){
          this.list_info.currentPage = 1
          this.list_info.pageSize = 5
          this.get_info()
        }
    },
  }
</script>

<style scoped>

  /deep/ .el-table tbody tr:hover > td {
    background-color: transparent !important;
    }
  .header_div {
    z-index: 9999;
  }

  .main {
    min-height: calc(100vh - 280px);
    width: 70%;
    padding: 20px;
    margin: 0 15%;
    z-index: 100;
    background-color: white;
  }

  .title {
    padding: 20px;
    overflow: hidden;
  }

  h1 {
    margin: 0;
  }

  /* 分页 */
  .block {
    margin: 30px 0;
  }
</style>



// WEBPACK FOOTER //
// src/view/index/Statute/Official_account_list.vue